import { queryOptions } from "@tanstack/react-query";
import { VolumeApi } from "./volume-api";
import { applicationApi } from "./application-api";
import { fxQueryKeys } from "./fx-query-keys";
import { queryRetry } from "./query-retry";

export const payinAccountsWithAggregatedBalancesQuery = (
  merchantId: string,
  accessToken: string,
  applicationId: string,
) => {
  const api = new VolumeApi(accessToken, applicationId);
  return queryOptions({
    queryKey: ["payin-accounts", merchantId],
    queryFn: () => api.getPayinAccountsWithAggregateBalances({ merchantId }),
  });
};

export const applicationConfigQuery = (
  applicationId: string,
  accessToken: string,
) => {
  return queryOptions({
    queryKey: fxQueryKeys.config(applicationId),
    queryFn: () =>
      applicationApi.getApplicationConfig(applicationId, accessToken),
    // Missing FX config is returned as { enabled: false }, so this query should
    // stay stable and avoid unnecessary background refetch churn. Refetching
    // on focus once stale picks up an admin enabling or disabling FX.
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: queryRetry(3),
  });
};
